import { API_STATES } from "@/helpers";
const state = {
  rulesGetState   : API_STATES.NOT_REQUESTED,
  rulesGetError   : null,
  ruleCreateState : API_STATES.NOT_REQUESTED,
  ruleCreateError : null,
  ruleUpdateState : API_STATES.NOT_REQUESTED,
  ruleUpdateError : null,
  ruleDeleteState : API_STATES.NOT_REQUESTED,
  ruleDeleteError : null,
  rules           : [],
  rule            : {}
};

export default state;
